import React from "react";
import { Typography, List, Space, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useBookingWizard } from "../../../contexts/BookingWizardContext";
import { formatEuro } from "../PricingCalculatorHelpers";
import { CalculatedPrices } from "../PricingCalculatorTypes";
import { CUSTOMS_CLEARANCE, HANDLING } from "../../../lib/pricingDefaults";

const { Text } = Typography;

interface CustomsHandlingSectionProps {
  calculatedPrices: CalculatedPrices;
}

export const CustomsHandlingSection: React.FC<CustomsHandlingSectionProps> = ({
  calculatedPrices,
}) => {
  const { state } = useBookingWizard();
  const { t } = useTranslation();

  if (
    state.currentStep <
    Math.min(CUSTOMS_CLEARANCE.DISPLAY_FROM_STEP, HANDLING.DISPLAY_FROM_STEP)
  ) {
    return null;
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Text strong>
        {t(
          "bookingWizard.pricingCalculator.customsHandlingSectionTitle",
          "Customs & Handling"
        )}
      </Text>
      <List size="small" itemLayout="horizontal" style={{ marginTop: 8 }}>
        {/* Customs clearance */}
        {state.currentStep >= CUSTOMS_CLEARANCE.DISPLAY_FROM_STEP && (
          <List.Item
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Space>
              <Text>
                {t(
                  "bookingWizard.pricingCalculator.customsClearance",
                  "Customs clearance"
                )}
              </Text>
              <Tooltip
                title={t(
                  "bookingWizard.pricingCalculator.customsClearanceTooltip",
                  `Base fee of €${CUSTOMS_CLEARANCE.BASE_FEE} includes up to ${CUSTOMS_CLEARANCE.INCLUDED_HS_CODES} unique HS codes. Each additional HS code costs €${CUSTOMS_CLEARANCE.EXTRA_HS_CODE_FEE}.`
                )}
              >
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
            <Text>{formatEuro(calculatedPrices.customsClearance)}</Text>
          </List.Item>
        )}

        {/* Handling fees */}
        {state.currentStep >= HANDLING.DISPLAY_FROM_STEP && (
          <List.Item
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Space>
              <Text>
                {t(
                  "bookingWizard.pricingCalculator.handlingFees",
                  "Handling fees"
                )}
              </Text>
              <Tooltip
                title={t(
                  "bookingWizard.pricingCalculator.handlingFeesTooltip",
                  "Fees for handling the shipment at warehouses"
                )}
              >
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
            <Text>{formatEuro(calculatedPrices.handlingFees)}</Text>
          </List.Item>
        )}
      </List>
    </div>
  );
};















